import React, { useMemo } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

import { StepDetectiveProvider } from '../../../../../components/csv-import/ui/components/step-detective/step-detective-context';
import { StepDetective } from '../../../../../components/csv-import/ui/components/step-detective/step-detective';
import messages from '../modal/messages';

import style from '../modal/style.module.less';

// Step IDs for the activation process
export const STEP_AUTHENTICATE = 'authenticate';
export const STEP_CARRIERS = 'carriers';
export const STEP_LOCATION = 'location';

// Path constants
export const ENHANCED_RETURNS_MODAL_PATH = '/settings/stores/enhancedReturns';
export const ENHANCED_RETURNS_MODAL_STORE_ACTIVATION_BASE_PATH = `${ENHANCED_RETURNS_MODAL_PATH}/activate`;
export const ENHANCED_RETURNS_MODAL_STORE_ACTIVATION_PATH = `${ENHANCED_RETURNS_MODAL_STORE_ACTIVATION_BASE_PATH}/:storeGuid`;
export const ENHANCED_RETURNS_MODAL_SETUP_CARRIER_PATH = `${ENHANCED_RETURNS_MODAL_STORE_ACTIVATION_PATH}/carrier-setup`;
export const ENHANCED_RETURNS_MODAL_SETUP_RETURN_LOCATION_PATH = `${ENHANCED_RETURNS_MODAL_STORE_ACTIVATION_PATH}/return-location`;
export const ENHANCED_RETURNS_MODAL_BLOCKED_PATH = `${ENHANCED_RETURNS_MODAL_STORE_ACTIVATION_PATH}/blocked`;
export const ENHANCED_RETURNS_MODAL_STORE_SETUP_COMPLETE_PATH = `${ENHANCED_RETURNS_MODAL_STORE_ACTIVATION_PATH}/setup-complete`;

export const EnhancedReturnsActivationStepDetective = () => {
  const location = useLocation();

  // Determine the current step based on the URL
  const isAuthenticating = Boolean(
    matchPath(location.pathname, {
      path: ENHANCED_RETURNS_MODAL_STORE_ACTIVATION_PATH,
      exact: true,
    }),
  );
  const isSettingReturnCarriers = Boolean(
    matchPath(location.pathname, {
      path: ENHANCED_RETURNS_MODAL_SETUP_CARRIER_PATH,
    }),
  );
  const isSettingReturnLocation = Boolean(
    matchPath(location.pathname, {
      path: ENHANCED_RETURNS_MODAL_SETUP_RETURN_LOCATION_PATH,
    }),
  );
  const isStoreListPage = Boolean(
    matchPath(location.pathname, {
      path: ENHANCED_RETURNS_MODAL_PATH,
      exact: true,
    }),
  );
  const isStoreSetupCompleteForEnhancedReturns = Boolean(
    matchPath(location.pathname, {
      path: ENHANCED_RETURNS_MODAL_STORE_SETUP_COMPLETE_PATH,
    }),
  );

  // Define the steps for the activation process
  const steps = useMemo(
    () => [
      {
        id: STEP_AUTHENTICATE,
        title: messages.reauthenticateStepTitle,
        isDone: isSettingReturnCarriers || isSettingReturnLocation || isStoreSetupCompleteForEnhancedReturns,
      },
      {
        id: STEP_CARRIERS,
        title: messages.setCarriersStepTitle,
        isDone: isSettingReturnLocation || isStoreSetupCompleteForEnhancedReturns,
      },
      {
        id: STEP_LOCATION,
        title: messages.setLocationStepTitle,
        isDone: isStoreSetupCompleteForEnhancedReturns,
      },
    ],
    [isSettingReturnCarriers, isSettingReturnLocation, isStoreSetupCompleteForEnhancedReturns],
  );

  // Determine the active step index
  let activeStepIndex = 0;
  if (isAuthenticating) activeStepIndex = 0;
  if (isSettingReturnCarriers) activeStepIndex = 1;
  if (isSettingReturnLocation) activeStepIndex = 2;

  return (
    <StepDetectiveProvider originalSteps={steps} startStep={steps[activeStepIndex]}>
      {!isStoreListPage && (
        <div className={style.modalStepper}>
          <StepDetective activeStepIndex={activeStepIndex} steps={steps} />
        </div>
      )}
    </StepDetectiveProvider>
  );
};

export default EnhancedReturnsActivationStepDetective;
